export function HomeIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 16">
            <path d="M18 9L14.625 5.625V0.5625H12.375V3.375L9 0L0 9V9.5625H2.25V15.1875H7.875V11.8125H10.125V15.1875H15.75V9.5625H18V9Z"/>
        </svg>
    )
}